import Quill from 'quill';

export function getQuill(): typeof Quill {
  return Quill;
}
